<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>chat</mat-icon>
				<span>
					@if( groupChatEditorMode == GroupChatEditorMode.edit ) {
						Gruppenchat bearbeiten
					}
					@else if( groupChatEditorMode == GroupChatEditorMode.view ) {
						Gruppenchat-Details
					}
					@else {
						Gruppenchat erstellen
					}
				</span>

			</div>

			@if( bInProgress ) {
				<mat-spinner diameter=20 />
			}

		</div>
		
		@if( bFirstLoading ) {
			<mat-progress-bar mode="indeterminate" />
		}
		@else if( bFirstLoadingError ) {
			<h4 style="text-align: center; color: red;">
				Beim Laden der Daten ist ein Fehler aufgetreten
			</h4>
		}
		@else {

			<div class="chatGroupEditor">
			
				<div class="newChatTitle">
					@if( chatGroup ) {
						{{chatGroup.title}}
					}
					@else if( bSystem ) {
						{{newTitle}}
					}
					@else {
						Neue Gruppe
					}
				</div>
					
				@if( groupChatEditorMode != GroupChatEditorMode.view ) {

					<div
						class="titleDiv maxWidth"
						[class.required]="bMissingTitle"
					>
				
						<span 
							class="material-icons"
							style="opacity: .6;"
						>title</span>
				
						<input
							type="text"
							placeholder="Titel"
							class="titleInput"
							[(ngModel)]="newTitle"
							(input)="onTitleChange()"
						>
				
					</div>

				}
			
				<div class="groupContactColumn">
			
					<div class="contactsLabel">Kontakte</div>
			
					<div class="contactIdChips">
						@for( contactId of contactIdsNewGroup; track contactId ) {
							<div
								class="contactIdChip txtWrap"
								(click)="clickToggleContactForGroup(contactId)"
								[title]="groupChatEditorMode == GroupChatEditorMode.view ? '' : 'Entfernen'"
								[style.cursor]="groupChatEditorMode == GroupChatEditorMode.view ? 'default' : 'cursor'"
							>
								<span class="txtWrap">
									{{ contactNames[contactId] || contactId }} ({{ contactVerein[contactId] }})
								</span>
								@if( groupChatEditorMode != GroupChatEditorMode.view ) {
									@if( contactBeingEdited[ contactId ] ) {
										<mat-spinner style="margin: 2px;" diameter="18" />
									}
									@else {
										<span class="material-icons removeBtn">
											close
										</span>
									}
								}
							</div>
						}
						@if( !contactIdsNewGroup.length ) {
							<div
								class="contactIdChip"
								style="background-color: transparent; color: lightgrey;"
							>
								<span>Noch kein Kontakt</span>
							</div>
						}
					</div>

					@if( groupChatEditorMode != GroupChatEditorMode.view ) {

						<div class="maxWidth">

							<div class="searchDiv">
					
								<span class="material-icons searchDiv__icon">search</span>
					
								<input
									type="text"
									placeholder="Kontakt suchen"
									class="searchInput"
									[(ngModel)]="strContactFilter"
									(input)="contactFilter($event)"
								>
					
							</div>
							
							<div class="contactPanel">
					
								@if( !contactsFiltered.length ) {
									<div class="noElements">
										Kein Kontakt wurde gefunden
									</div>
								}
								@else {

									<table
										class="contactTable"
										matSort 
										(matSortChange)="sortData($event)"
										[matSortDisableClear]="true"
										[matSortActive]="'contactName'"
										[matSortDirection]="'asc'"
									>
			
										<thead>
											<tr>
												<th></th>
												<th mat-sort-header="contactName">Name</th>
												<th mat-sort-header="contactMiglied">Verein</th>
											</tr>
										</thead>
						
										<tbody>
		
											@for( contact of contactsFiltered; track contact.ebeId ) {
								
												<tr
													class="contactGroupToggle"
													role="button"
													tabindex="0"
													(click)="clickToggleContactForGroup(contact.ebeId)"
													(keydown.enter)="clickToggleContactForGroup(contact.ebeId)"
													(keydown.space)="clickToggleContactForGroup(contact.ebeId); $event.preventDefault()"
													[class.is-selected]="contactIdsNewGroup.includes(contact.ebeId)"
													[attr.aria-pressed]="contactIdsNewGroup.includes(contact.ebeId)"
												>

													<td class="contactTable__avatarCell">
														<img
															class="contactAvatarImg"
															[src]="contactAvatarUrls[contact.ebeId] || defaultAvatar"
															[attr.alt]="contactNames[contact.ebeId] || contact.ebeId"
															loading="lazy"
														/>
													</td>

													<td class="txtWrap">
														{{ contactNames[contact.ebeId] || contact.ebeId }}
													</td>

													<td class="txtWrap contactTable__vereinCell">
														@if( contactBeingEdited[ contact.ebeId ] ) {
															<mat-spinner diameter="20"></mat-spinner>
														}
														@else if( contactIdsNewGroup.includes(contact.ebeId) ) {
															<span class="rowCheck">
																<span class="material-icons" aria-label="Ausgewählt">check_circle_outline</span>
															</span>
														}
														{{ contactVerein[contact.ebeId] || '' }}
													</td>
		
												</tr>
		
											}
		
										</tbody>
			
									</table>

								}
					
							</div>

						</div>

					}
			
				</div>

				<div style="text-align: center;">
					<mat-checkbox
						[(ngModel)]="bNotifications"
						(input)="onNotificationClick()"
						[disabled]="bInProgress"
					>
						Benachrichtigungen per E-Mail erhalten
					</mat-checkbox>
				</div>

				<div class="maxWidth">
					<div
						class="saveError"
						[style.opacity]="(bMissingTitle || bNotEnoughMembers || bSavingError) ? 1 : 0"
					>
						<span class="material-icons">error</span>
						@if( bMissingTitle ) {
							<span>Ein Titel ist erforderlich</span>
						}
						@if( bNotEnoughMembers ) {
							<span>Die Gruppe muss mindestens 3 Kontakte enthalten</span>
						}
						@if( bSavingError ) {
							<span>Beim Speichern der Gruppe ist ein Fehler aufgetreten</span>
						}
					</div>
				</div>

				<div class="newGroupButtons">
				
					<button
						mat-raised-button
						[disabled]="bInProgress"
						[routerLink]="['..']"
						[queryParams]="chatId ? { chatId: chatId } : {}"
					>
						Zurück
					</button>
			
					@if( groupChatEditorMode == GroupChatEditorMode.create ) {

						<button
							mat-flat-button
							[disabled]="bInProgress"
							(click)="clickCreateGroup()"
						>
							Erstellen
						</button>

					}
			
				</div>

				@if( tmsLastSave ) {
					<div class="autoSaveInfo">
						<span class="material-icons">save</span>
						Automatisch gespeichert um {{ tmsLastSave | date: 'HH:mm:ss' }}
					</div>
				}

			</div>

		}

	</div>

</div>

